const chat = require('./calls/chat');
const events = require('./calls/events');
const forms = require('./calls/forms');
const meetings = require('./calls/meetings');
const misc = require('./calls/misc');
const notes = require('./calls/notes');
const notifications = require('./calls/notifications');
const questions = require('./calls/questions');
const reports = require('./calls/reports');
const session = require('./calls/session');
const collect = require('./calls/collect');
const uploads = require('./calls/uploads');
const users = require('./calls/users');
const virtualRooms = require('./calls/virtualRooms');
const voting = require('./calls/voting');
const stats = require('./calls/stats');
const participants = require('./calls/participants');
const participantFilters = require('./calls/participantFilters');
const directory = require('./calls/directory');
const tasks = require('./calls/tasks');
const program = require('./calls/program');
const leads = require('./calls/leads');
const emailTemplates = require('./calls/emailTemplates');
const emails = require('./calls/emails');
const matchmaking = require('./calls/matchmaking');
const { setBaseURL, setSocketURL, setAuthToken, setCSRFToken, getCSRFToken, setClientId, setOptions } = require('./connection');

module.exports = {
    setBaseURL,
    setSocketURL,
    setAuthToken,
    setCSRFToken,
    getCSRFToken,
    setClientId,
    setOptions,
    session,
    users,
    events,
    meetings,
    questions,
    notifications,
    chat,
    voting,
    forms,
    uploads,
    misc,
    reports,
    notes,
    virtualRooms,
    collect,
    stats,
    participants,
    participantFilters,
    directory,
    tasks,
    program,
    leads,
    emailTemplates,
    emails,
    matchmaking,
};
